import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  dir: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      text: PropTypes.string.isRequired,
    })).isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

const SingleQuestion = ({ dir = null, onSubmit, question }) => {
  const handleClick = event => {
    const answer = event.target.value;
    onSubmit(question.id, { selectedOptionIds: [answer] });
  };

  return (
    <div className="question question--single" dir={dir}>
      <p className="question__body">{question.text}</p>

      <div className="question__answers">
        <ul className="list-unstyled">
          {question.options.map(option => (
            <li key={option.id}>
              <button
                className="question__answer question__btn"
                data-test="questionButton"
                onClick={handleClick}
                type="button"
                value={option.id}
              >
                {option.text}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

SingleQuestion.propTypes = propTypes;

export default SingleQuestion;
